import type { ConnatixPlayerApi } from '@/connatix/connatixTypes'
import { CommunicationService } from '@/utils/communication/communicationService'

const playerName = 'Connatix'
export function handleFloating(
    playerApi: ConnatixPlayerApi,
    communicationService: CommunicationService,
) {
    playerApi.on('closeButtonClicked', () => {
        communicationService.broadcast({
            type: '[Video] Close button clicked',
            payload: {
                player: playerName,
            },
        })
    })
}
